import styled from 'styled-components';

export const Container = styled.div`
  margin: 0;
  width: 100%;
  max-width: 600px;
  background-color: #FFF;
  border: 1px solid var(--light-blue);
  border-radius: 0.25rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 1rem;

  .loading {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
  }

  img {
    width: 100px;
    height: 80px;
    margin-bottom: 1.5rem;
  }

  strong {
    color: var(--dark-blue);
  }

  .progress-bar {
    width: 6rem;
    height: 6rem;
    border-radius: 50%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: .5rem;
    img {
      width: auto;
      height: 50px;
      margin: 0;
      position: absolute;
    }
  }
  .card-text {
    margin-left: 1rem;
    strong {
      color: var(--dark-blue);
      font-size: 1.2rem;
    }
    p {
      font-size: 1rem;
    }
  }

  @media (min-width: 1100px) {
    img {
      width: 5.2rem;
      height: auto;
    }
    .progress-bar {
      width: 5.2rem;
      height: 5.2rem;
    }
  }

  @media (max-width: 520px) {
    width: 90%;
    margin: 0 auto;
    margin-bottom: 1rem;
  }

`;
